<template>
  <popup :title="title" class="approved-error-popup" ref="errorPopup"></popup>
</template>

<script setup lang="ts">
  import { defineExpose, markRaw, nextTick, ref } from "vue";
  import Popup from "@/components/_partials/Popup.vue";
  import { ErrorPopup } from "@/components/_partials/lot-info-popup";
  import { trans } from "@/utils/trans";

  const errorPopupComponent = markRaw(ErrorPopup);
  const errorPopup = ref<typeof Popup>(null);

  const defaultTitle = trans("modals.error_popup.title");
  const title = ref<string>(defaultTitle);

  const openPopup = (errors = []) => {
    title.value = defaultTitle;
    const errorValues = Object.values(errors);
    for (const errorArray of errorValues) {
      if (errorArray.length) {
        title.value = errorArray[0]?.title || defaultTitle;
        break;
      }
    }

    nextTick(() => {
      errorPopup.value.toggleComponent(errorPopupComponent, { errors });
      errorPopup.value.open();
    });
  };

  defineExpose({
    openPopup
  });
</script>
